import { render } from "./NavigationBar.vue?vue&type=template&id=01557b86"
const script = {}

import "./NavigationBar.vue?vue&type=style&index=0&id=01557b86&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__